import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

import {
  OptionType,
  AccountSettings,
  PermissionsType,
} from 'src/features/AddEditUsers/types/userStoreTypes';

import { emailRegex } from 'src/utils/common';

function validateEmail(email: string): boolean {
  if (!emailRegex.test(email.trim())) return false;
  return true;
}

function hasNonEmptyValues(obj: Record<string, any>): boolean {
  const obj1: Record<string, any> = { ...obj };
  delete obj1.id;
  delete obj1.status;
  for (const key in obj1) {
    if (obj1.hasOwnProperty(key) && obj1[key] !== '') {
      return true;
    }
  }
  return false;
}

function hasAllValuesPresent(obj: Record<string, any>): boolean {
  const obj1: Record<string, any> = { ...obj };
  delete obj1.id;
  delete obj1.status;
  for (let key in obj1) {
    if (obj1.hasOwnProperty(key)) {
      const value = obj1[key];
      const trimmedValue = value?.trim();
      if (trimmedValue === undefined || trimmedValue === '') {
        return false;
      }
    }
  }
  return true;
}

function getAllLimittedAccAccounts(
  accountQuestionSettings: Array<AccountSettings> | undefined,
): Array<number> | undefined {
  return accountQuestionSettings
    ?.filter(settings => settings.AccessTypeId === 1)
    ?.map(({ AccountId }) => AccountId);
}

function hasLimittedAccess(
  accountQuestionSettings: Array<AccountSettings> | undefined,
): boolean {
  let questions = accountQuestionSettings?.filter(
    settings => settings.AccessTypeId === 1,
  );
  if (questions && questions?.length > 0 && questions !== null) return true;
  return false;
}

// to find the acounts with limiter
function getAllLimiterAccounts(
  accountQuestionSettings: Array<AccountSettings> | undefined,
): Array<number> | undefined {
  return accountQuestionSettings
    ?.filter(settings => settings.AccountCategoryLimitingValues.length > 0)
    ?.map(({ AccountId }) => AccountId);
}

function limiterAccountsHaveNoOptions(
  limiterAccounts: any,
  optionsByAccount: any,
) {
  return limiterAccounts.some((accountId: any) => {
    const options = optionsByAccount?.[accountId];

    return !options || (Array.isArray(options) && options.length === 0);
  });
}

function validateRequest(
  selectedOptions: Array<OptionType>,
  accountQuestionSettings: Array<AccountSettings> | undefined,
  userSettingsPermissions: Array<PermissionsType> | undefined,
  selectedChoiceOptions: Array<any>,
  optionsByAccount: Record<number, Array<OptionType>> | undefined,
): boolean {
  // lookup or choice selected
  const hasLookupOrChoiceSelected = getAllLimittedAccAccounts(
    accountQuestionSettings,
  )?.every(accountId => {
    return (
      selectedOptions.some(item => item.AccountId === accountId) ||
      selectedChoiceOptions.some(item => item.AccountId === accountId)
    );
  });
  let documentPresent = userSettingsPermissions?.findIndex(
    item => item?.ClaimType === 'DocumentTransmissionPermission',
  );

  let limiterAccess = userSettingsPermissions?.findIndex(
    item => item.ClaimType === 'CanViewPersonAlerts',
  );

  if (
    (documentPresent === -1 || documentPresent === undefined) &&
    (limiterAccess === -1 || limiterAccess === undefined)
  )
    return false;

  const limiterAccounts = getAllLimiterAccounts(accountQuestionSettings);

  const hasNoOptionsSelected =
    !optionsByAccount ||
    Object.keys(optionsByAccount).length === 0 ||
    Object.values(optionsByAccount).some(
      options => Array.isArray(options) && options.length === 0,
    ) ||
    limiterAccountsHaveNoOptions(limiterAccounts, optionsByAccount);

  const hasAnyLimitingValues = accountQuestionSettings?.some(
    account =>
      Array.isArray(account?.AccountCategoryLimitingValues) &&
      account.AccountCategoryLimitingValues.length > 0,
  );

  //to show the validation error if the account has limiter and no options selected
  const shouldShowError = hasAnyLimitingValues && hasNoOptionsSelected;

  const shouldDisable =
    (hasLimittedAccess(accountQuestionSettings) &&
      selectedOptions.length === 0 &&
      selectedChoiceOptions.length === 0 &&
      documentPresent !== -1 &&
      documentPresent !== undefined) ||
    (limiterAccess !== undefined && limiterAccess !== -1 && shouldShowError) ||
    !hasLookupOrChoiceSelected;

  return shouldDisable;
}

export {
  validateEmail,
  hasNonEmptyValues,
  hasAllValuesPresent,
  validateRequest,
};
